"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Metadata_1 = require("./_Metadata");
exports.GetObjectOutput = {
    type: "structure",
    required: [],
    members: {
        Body: {
            shape: {
                type: "blob"
            },
            streaming: true
        },
        DeleteMarker: {
            shape: {
                type: "boolean"
            },
            location: "header",
            locationName: "x-amz-delete-marker"
        },
        AcceptRanges: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "accept-ranges"
        },
        Expiration: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-expiration"
        },
        Restore: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-restore"
        },
        LastModified: {
            shape: {
                type: "timestamp"
            },
            location: "header",
            locationName: "Last-Modified"
        },
        ContentLength: {
            shape: {
                type: "integer"
            },
            location: "header",
            locationName: "Content-Length"
        },
        ETag: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "ETag"
        },
        MissingMeta: {
            shape: {
                type: "integer"
            },
            location: "header",
            locationName: "x-amz-missing-meta"
        },
        VersionId: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-version-id"
        },
        CacheControl: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "Cache-Control"
        },
        ContentDisposition: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "Content-Disposition"
        },
        ContentEncoding: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "Content-Encoding"
        },
        ContentLanguage: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "Content-Language"
        },
        ContentRange: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "Content-Range"
        },
        ContentType: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "Content-Type"
        },
        Expires: {
            shape: {
                type: "timestamp"
            },
            location: "header",
            locationName: "Expires"
        },
        WebsiteRedirectLocation: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-website-redirect-location"
        },
        ServerSideEncryption: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-server-side-encryption"
        },
        Metadata: {
            shape: _Metadata_1._Metadata,
            location: "headers",
            locationName: "x-amz-meta-"
        },
        SSECustomerAlgorithm: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-server-side-encryption-customer-algorithm"
        },
        SSECustomerKeyMD5: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-server-side-encryption-customer-key-MD5"
        },
        SSEKMSKeyId: {
            shape: {
                type: "string",
                sensitive: true
            },
            location: "header",
            locationName: "x-amz-server-side-encryption-aws-kms-key-id"
        },
        StorageClass: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-storage-class"
        },
        RequestCharged: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-request-charged"
        },
        ReplicationStatus: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-replication-status"
        },
        PartsCount: {
            shape: {
                type: "integer"
            },
            location: "header",
            locationName: "x-amz-mp-parts-count"
        },
        TagCount: {
            shape: {
                type: "integer"
            },
            location: "header",
            locationName: "x-amz-tagging-count"
        }
    },
    payload: "Body"
};
//# sourceMappingURL=GetObjectOutput.js.map